import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7373846f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "browse-view" }
const _hoisted_2 = ["src", "alt", "onClick"]
const _hoisted_3 = { class: "btn-box" }
const _hoisted_4 = {
  key: 0,
  class: "bottom-seat"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("目录列表"),
    _createVNode($setup["chapterListMenu"], {
      onBefore: $setup.before,
      onNext: $setup.next,
      onChangeChapter: $setup.change_chapter
    }),
    _createCommentVNode(" 书签 "),
    _createVNode($setup["bookmark"], {
      page: $setup.currentPage,
      chapterId: $setup.chapterInfo.chapterId
    }, null, 8 /* PROPS */, ["page", "chapterId"]),
    _createCommentVNode(" 下拉刷新 "),
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
      onRefresh: $setup.before_page
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" 列表 "),
        _createElementVNode("div", {
          onClick: $setup.switch_menu,
          id: "flowList",
          ref: "flowList"
        }, [
          _createVNode(_component_van_list, {
            loading: $setup.loading,
            "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
            finished: $setup.finished,
            "immediate-check": false,
            onLoad: $setup.page_change
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imgFileList, (k, i) => {
                return (_openBlock(), _createElementBlock("img", {
                  ref_for: true,
                  ref: 'flow-' + i,
                  class: "list-img",
                  src: k,
                  key: k,
                  alt: $setup.t('browse.imgLoadError'),
                  onClick: ($event: any) => ($setup.load_image(i))
                }, null, 8 /* PROPS */, _hoisted_2))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "finished"])
        ], 512 /* NEED_PATCH */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createCommentVNode(" 翻页按钮 "),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        class: "btn",
        type: "warning",
        plain: "",
        onClick: $setup.before
      }, {
        default: _withCtx(() => [
          _createTextVNode("上一章")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "success",
        plain: "",
        onClick: $setup.next
      }, {
        default: _withCtx(() => [
          _createTextVNode("下一章")
        ]),
        _: 1 /* STABLE */
      })
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.imgFileList.length]
    ]),
    _createCommentVNode(" 页码 "),
    _createVNode($setup["pageNumber"], {
      page: $setup.currentPage,
      count: $setup.imgPathList.length
    }, null, 8 /* PROPS */, ["page", "count"]),
    _createCommentVNode(" 功能菜单 "),
    _createVNode($setup["rightSidebar"], { onDwonload: $setup.dwonload_image }),
    _createCommentVNode(" 安卓端占位符 "),
    ($setup.config.android)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("v-if", true)
  ]))
}